import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { Providers } from './components/Providers';

export function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
